<!--
 Copyright 2022 by DomX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of DomX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">
    <v-snackbar
      :value.sync="snackbarVisible"
      :timeout="snackbarTimeout"
      :color="snackbarColor"
      :multi-line="true"
      elevation="24"
    >
      {{ snackbarText }}
    </v-snackbar>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'

import { commonModule } from '@/store/modules/store-accessor'

@Component
export default class TheSnackbar extends Vue {

  get snackbarVisible () {
    return commonModule.snackbar.visible
  }

  get snackbarColor () {
    return commonModule.snackbar.color
  }

  get snackbarTimeout () {
    return commonModule.snackbar.timeout
  }

  get snackbarText () {
    return commonModule.snackbar.text
  }

};
</script>
